import { Trophy } from "lucide-react";
import ResourceShellTemplate from "./ResourceShellTemplate";

export default function CaseStudiesShell() {
  return (
    <ResourceShellTemplate
      slug="case-studies"
      eyebrow="Resources · Case Studies"
      title="Real operators."
      titleAccent="Cited numbers. Real deals."
      subtitle="How teams cut underwriting from 90 to 6 minutes, replaced 3 BI dashboards with one platform, and tripled BRRRR cycles per year — with the exact metrics that moved."
      icon={Trophy}
      previewItems={[
        { title: "Cleveland wholesale team — 42 assignments in 12 months, solo", desc: "How one operator went from 90-minute underwriting to 6 minutes and stopped losing sellers to slow numbers.", meta: "Wholesale · Solo" },
        { title: "Ohio buy-and-hold fund — $412k of equity recycled in one quarter", desc: "Portfolio Intelligence caught three refi-ready properties the operator hadn't noticed. Recycled capital, no manual audit.", meta: "Buy-and-Hold · 22 doors" },
        { title: "Multi-market fix-and-flip — 6% avg. ARV variance vs actual sale", desc: "Stopped over-improving. Strategy Comparison caught wholetail-vs-flip opportunities worth $18k on the same property.", meta: "Fix-and-Flip · 14 projects/yr" },
        { title: "Enterprise fund — 3 BI dashboards replaced by one platform", desc: "LP letters wrote themselves. Every metric cited, every mutation audited. Board-ready from day one.", meta: "Enterprise · 6 markets" },
      ]}
    />
  );
}
